import { useMemo } from 'react'

import { Option } from '@joor/design-system'

import { BrandStartOrderIds } from 'modals/OrderList/StartOrderModal/StartOrderModal.ids'

import { getDesignSystemOptionId } from '../../BrandStartOrderModal.formatters'
import messages from '../../BrandStartOrderModal.messages'
import { StyledDropdown } from './WarehouseDropdown.styles'

interface WarehouseDropdownProps {
  options: Option[]
  value: string | null | undefined
  setSelectedWarehouseId: (warehouseId: string) => void
}

export const WarehouseDropdown = ({
  options,
  value,
  setSelectedWarehouseId,
}: WarehouseDropdownProps) => {
  const selectedOption = useMemo(
    () =>
      options.find((option) => getDesignSystemOptionId(option) === value) ??
      null,
    [options, value],
  )

  const handleSelect = ({ selected }: { selected: Option }) => {
    setSelectedWarehouseId(getDesignSystemOptionId(selected))
  }

  return (
    <StyledDropdown
      id={BrandStartOrderIds.WarehouseOptions}
      testId={BrandStartOrderIds.WarehouseOptions}
      labelId={BrandStartOrderIds.WarehouseTitle}
      label={messages.selectOrderWarehouse}
      options={options}
      value={selectedOption}
      translateOptions={false}
      onSelect={handleSelect}
      placeholder={messages.selectOne}
    />
  )
}
